import React from 'react';
import _ from 'lodash';
const { compose, withProps, lifecycle } = require('recompose');
const { withScriptjs } = require('react-google-maps');
const {
  StandaloneSearchBox
} = require('react-google-maps/lib/components/places/StandaloneSearchBox');

const PlacesWithStandaloneSearchBox = compose(
  withProps({
    googleMapURL:
      `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '400px' }} />
  }),
  lifecycle({
    componentWillMount() {
      const refs = {};

      this.setState({
        places: [],
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();

          this.setState({
            places
          });
          this.props.onChange(places[0]);
        }
      });
    }
  }),
  withScriptjs
)(props => {
  const vMsgRef = React.useRef(null);
  const AutocompleteRef = React.useRef(null);

  return (
    <div className="form-group SimpleInput LocAutocomplete" style={{ zIndex: 9 }}>
      <label htmlFor="eventLocation">Event location (required)</label>
      <div data-standalone-searchbox="">
        <StandaloneSearchBox
          ref={props.onSearchBoxMounted}
          bounds={props.bounds}
          onPlacesChanged={props.onPlacesChanged}
        >
          <div>
            <input
              ref={AutocompleteRef}
              type="text"
              placeholder=" "
              value={props.value.formatted_address}
              style={{
                boxSizing: 'border-box',
                border: '1px solid transparent',
                width: '100%',
                outline: 'none',
                textOverflow: 'ellipses'
              }}
              onChange={(e: any) => {
                const editorField = _.get(AutocompleteRef, 'current.refs.input', null);

                if (editorField) {
                  editorField.classList.remove('validationElement');
                }

                vMsgRef.current.style.display = 'none';
                props.onChangeOnlyValue(e.target.value);
              }}
              className="form-control"
            />
            <div
              className='Autocomplete-vMsg vMsg'
              ref={vMsgRef}
            >
              This field is required.
            </div>
          </div>
        </StandaloneSearchBox>
      </div>
    </div>
  );
});

export default PlacesWithStandaloneSearchBox;
